export default class PhotoAPI {
  private static readonly STONE_XX = 11833973;
  private static readonly IMAGE_PATH = "//bi.im-g.pl/im/";
  private static readonly REGEX_PHOTO_FORMAT = /(z\d+)[A-Z]+/;

  public static photoFromUrl(url: string, format: string): string {
    return url.replace(PhotoAPI.REGEX_PHOTO_FORMAT, "$1" + format);
  }

  public static photoFromXX(imageId: string, format: string, fileType: string): string {
    const xx = Number(imageId);
    let url = "";
    let l = 0;
    let tmp = "";

    if (xx) {
      if (xx > 16777215) {
        tmp = xx.toString(16);
        url = `${this.IMAGE_PATH}${tmp.substring(5, 7)}/${tmp.substring(2, 4)}/${tmp.substring(
          0,
          2
        )}/z${xx}${format}.${fileType}`;
      } else if (xx > this.STONE_XX) {
        tmp = xx.toString(16);
        url = `${this.IMAGE_PATH}${tmp.substring(4, 6)}/${tmp.substring(2, 4)}/${tmp.substring(
          0,
          2
        )}/z${xx}${format}.${fileType}`;
      } else {
        tmp = xx.toString(10);
        l = tmp.length;
        url = `${this.IMAGE_PATH}${tmp.substring(l - 1, l)}/${tmp.substring(0, l - 3)}/z${tmp}${format}.${fileType}`;
      }
    }

    return url;
  }
}
